'use strict';

const isInstanceOf = require('../rlink-type-utils/isInstanceOf');
const simpleCheckerFactory = require('../rlink-shapes/simpleCheckerFactory');

module.exports.array = simpleCheckerFactory('array',
  Array.isArray,
  'is not an array',
  () => []
);

module.exports.bool = simpleCheckerFactory('bool',
  value => isInstanceOf(value, Boolean),
  'is not a boolean'
);

module.exports.func = simpleCheckerFactory('func',
  value => isInstanceOf(value, Function),
  'is not a function'
);

module.exports.object = simpleCheckerFactory('object',
  value => typeof value === 'object' && value !== null,
  'is not a non-null object',
  () => ({})
);

module.exports.number = simpleCheckerFactory('number',
  value => isInstanceOf(value, Number),
  'is not a number'
);

module.exports.string = simpleCheckerFactory('string',
  value => isInstanceOf(value, String),
  'is not a string',
  () => ''
);

module.exports.symbol = simpleCheckerFactory('symbol',
  value => isInstanceOf(value, Symbol),
  'is not a symbol'
);



// WEBPACK FOOTER //
// ./lib/rlink-shapes/primitives.js